export default __webpack_public_path__ + "static/media/ic_wftm_40.45405253.svg";